"use strict";
/**
 * Refusals the servers of every host give and the App runtime core words for
 * the page. Plain constants only: the core bundle of every page imports them.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_RULE_VIOLATED_MESSAGE = exports.APP_BASE_ATTACHMENT_TOO_LARGE_MESSAGE = exports.APP_BASE_INVOCATION_RATE_LIMITED = exports.APP_BASE_ATTACHMENT_DOWNLOAD_NOT_DECLARED = exports.APP_BASE_ATTACHMENT_TOO_LARGE = exports.appBaseAttachmentRefusal = exports.APP_BASE_ATTACHMENT_REFUSALS = void 0;
/**
 * The refusals of the file ways (upload, copy, file action, download,
 * removal), the same on every server: each answer names its code, the words
 * are for the log.
 */
exports.APP_BASE_ATTACHMENT_REFUSALS = {
    APP_BASE_ATTACHMENT_ACTION_UNAVAILABLE: 'App file action is unavailable',
    APP_BASE_ATTACHMENT_BLOB_NOT_FOUND: 'App file content was not found',
    APP_BASE_ATTACHMENT_CAPACITY_EXHAUSTED: 'App file uploads are at their limit; try again later',
    APP_BASE_ATTACHMENT_CLIENT_ABORTED: 'App file upload was aborted',
    APP_BASE_ATTACHMENT_COLUMN_NOT_ATTACHMENT: 'App file column does not hold files',
    APP_BASE_ATTACHMENT_COLUMN_NOT_EXPOSED: 'App file column is not exposed',
    APP_BASE_ATTACHMENT_COMMAND_INVALID: 'App file command is invalid',
    APP_BASE_ATTACHMENT_CONTENT_LENGTH_INVALID: 'App file request has an invalid length',
    APP_BASE_ATTACHMENT_CONTENT_LENGTH_REQUIRED: 'App file request needs a length',
    APP_BASE_ATTACHMENT_DIGEST_MISMATCH: 'App file does not match its declared digest',
    APP_BASE_ATTACHMENT_DOWNLOAD_NOT_DECLARED: 'App Container attachment download is not declared',
    APP_BASE_ATTACHMENT_EMPTY: 'App file is empty',
    APP_BASE_ATTACHMENT_FILENAME_REQUIRED: 'App file needs a name',
    APP_BASE_ATTACHMENT_FILE_INVALID: 'App file part is invalid',
    APP_BASE_ATTACHMENT_INVALID: 'App file value names no file',
    APP_BASE_ATTACHMENT_METADATA_INVALID: 'App file metadata is invalid',
    APP_BASE_ATTACHMENT_METADATA_MISMATCH: 'App file metadata does not match the action',
    APP_BASE_ATTACHMENT_MULTIPART_INVALID: 'App file request is malformed',
    APP_BASE_ATTACHMENT_MULTIPART_REQUIRED: 'App file request must be multipart',
    APP_BASE_ATTACHMENT_MULTIPART_ROUTE_REQUIRED: 'App files go through the file route',
    APP_BASE_ATTACHMENT_NOT_FOUND: 'App file was not found',
    APP_BASE_ATTACHMENT_PARTS_INVALID: 'App file request has invalid parts',
    APP_BASE_ATTACHMENT_REMOVE_NOT_DECLARED: 'This file action does not remove files',
    APP_BASE_ATTACHMENT_RETRY_NOT_READY: 'App file upload is not ready for a retry',
    APP_BASE_ATTACHMENT_ROUTE_REQUIRES_ATTACHMENT_ACTION: 'The file route takes file actions only',
    APP_BASE_ATTACHMENT_ROW_NOT_FOUND: 'App file row was not found',
    APP_BASE_ATTACHMENT_ROW_REQUIRED: 'App file call names no row',
    APP_BASE_ATTACHMENT_SIZE_MISMATCH: 'App file does not match its declared size',
    APP_BASE_ATTACHMENT_SIZE_REQUIRED: 'App file needs a declared size',
    APP_BASE_ATTACHMENT_STREAM_STALLED: 'App file upload stalled',
    APP_BASE_ATTACHMENT_STREAM_TIMEOUT: 'App file upload took too long',
    APP_BASE_ATTACHMENT_TYPE_REFUSED: 'App file type is not accepted',
    APP_BASE_ATTACHMENT_TOO_LARGE: 'App file is too large',
};
/** The answer of the file refusal `code`: its code and its words. */
const appBaseAttachmentRefusal = (code) => ({
    code,
    message: exports.APP_BASE_ATTACHMENT_REFUSALS[code],
});
exports.appBaseAttachmentRefusal = appBaseAttachmentRefusal;
/** The refusal of a file over the limit of its action. */
exports.APP_BASE_ATTACHMENT_TOO_LARGE = (0, exports.appBaseAttachmentRefusal)('APP_BASE_ATTACHMENT_TOO_LARGE');
/** The refusal of a download the App does not declare. */
exports.APP_BASE_ATTACHMENT_DOWNLOAD_NOT_DECLARED = (0, exports.appBaseAttachmentRefusal)('APP_BASE_ATTACHMENT_DOWNLOAD_NOT_DECLARED');
/** The refusal of an App call over its rate, the same on every server. */
exports.APP_BASE_INVOCATION_RATE_LIMITED = {
    code: 'APP_BASE_INVOCATION_RATE_LIMITED',
    message: 'App calls are at their limit; try again later',
};
/** The words of that refusal on the page. */
exports.APP_BASE_ATTACHMENT_TOO_LARGE_MESSAGE = {
    de: 'Die Datei ist zu groß.',
    en: 'The file is too large.',
};
/** The words of a write the rules of the App refuse (AppRuleViolatedError). */
exports.APP_RULE_VIOLATED_MESSAGE = {
    de: 'Die Regeln der App lassen diese Änderung nicht zu.',
    en: 'The rules of the App refuse this change.',
};
